<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
    <el-select
        size="medium"
        v-model="searchForm.coinInfoId"
        placeholder="请选择币种"
        @change="getTableList"
        clearable 
        >
        <el-option
            v-for="item in coinInfoList"
            :key="item.id"
            :label="item.coin"
            :value="item.id"
        ></el-option>
    </el-select>

      <el-date-picker
       size="medium"
        v-model="searchForm.startTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsStart"
        placeholder="请选择开始时间">
      </el-date-picker>
      <el-date-picker
        size="medium"
        v-model="searchForm.endTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
        placeholder="请选择结束时间">
      </el-date-picker>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
             <a :href="url+'/coinPrice/coinPriceDaily/export?startTime='+searchForm.startTime 
                     + '&endTime='+searchForm.endTime 
                     + '&coinInfoId='+searchForm.coinInfoId
                     + '&page='+searchForm.page
                     + '&pageSize='+searchForm.pageSize
                 " style="margin-left:20px">
            <el-button size="medium" type="warning" icon="el-icon-folder-opened" style="margin-left:20px">导出</el-button>
       </a>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <el-table-column
      prop="name"
      label="交易对">
    </el-table-column>
    <el-table-column
      prop="high"
      label="最高价">
    </el-table-column>
    <el-table-column
      prop="low"
      label="最低价">
    </el-table-column>
    <el-table-column
      prop="avg"
      label="均价">
    </el-table-column>
    <el-table-column
      prop="date"
      label="数据日期">
    </el-table-column>
    <el-table-column
      prop="createTime"
      label="创建时间">
    </el-table-column>
  
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var checkNum = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error('输入不能为空'));
      }else {
        if (value !=parseInt(value)) {
          callback(new Error('输入必须为正整数'));
        } else if (value < 0) {
          callback(new Error('输入不能为负值'));
        } else {
          callback();
        }
      }
    };
    var checkNum1 = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error("请输入正确的数值"));
      } else if (value <= 0) {
        callback("输入必须为正数");
      }else {
        callback()
      }
    };
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:20,
        startTime: '',
        endTime: '',
        miningStatus: 0,
        coinInfoId: ""
      },
      tableData: [],

      userId: '',
      balance: 0,
      balanceTwo: 0,
      url: window.g.host,
      coinInfoList: []
    };
  },
  created() {
    this.getCoinInfoList()
    this.getTableList()
  },
  methods: {
    async getCoinInfoList() {
        let res = await this.$http.coinInfoApi()
        if(res) {
            this.coinInfoList = res.data
        }
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.coinPriceApi({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
